import { UTC }                                      from 'rewire-common';
import DataMutations                                from '../graphql/Mutations';
import ArchiveDeleteDialogModel                     from './ArchiveDeleteDialogModel';
import { ArchiveDeleteEmployeeConfirmationContent } from './ArchiveDeleteEmployeeDialog';

export class ArchiveDeleteEmployeeDialogModel extends ArchiveDeleteDialogModel {
  constructor() {
    super('employees');
  }

  async _delete(id: string, endDate: UTC): Promise<boolean> {
    return !!(await DataMutations.deleteEmployees([id], endDate));
  }

  _getConfirmationContentComponent() {
    return ArchiveDeleteEmployeeConfirmationContent;
  }
}

const archiveDeleteEmployeeDialogModel = new ArchiveDeleteEmployeeDialogModel();
export default archiveDeleteEmployeeDialogModel;